module.exports = __webpack_public_path__ + "img/birdslife_bottomimage6.40423705.jpg";